import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=bd49d290&scoped=true"
import script from "./monitoring.vue?vue&type=script&lang=js"
export * from "./monitoring.vue?vue&type=script&lang=js"
import style0 from "./monitoring.vue?vue&type=style&index=0&id=bd49d290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd49d290",
  null
  
)

export default component.exports